import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import { capitalizeFirstLetter } from "../utils/utils";

const ButtonBack = ({ profileRole }) => {
  const location = useLocation();
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div>
      <Button
        color="soft-primary"
        size="md"
        className="py-0 d-flex align-items-center border border-primary"
        onClick={handleBack}
      >
        <i className="ri-arrow-left-line fs-3 me-1"></i> Back{" "}
      </Button>
    </div>
  );
};

export default ButtonBack;
